var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgSharePurple = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5BEE",
    stroke: "#5C5BEE",
    strokeWidth: 0.125,
    d: "m13.783 16.183.043.028.036-.037A3.68 3.68 0 0 1 16.5 15.06a3.687 3.687 0 1 1-3.437 2.354l.018-.047-.043-.028-4.322-2.778-.043-.028-.035.037a3.687 3.687 0 1 1 0-5.146l.035.037.043-.028 4.322-2.778.043-.028-.018-.047a3.683 3.683 0 1 1 .798 1.24l-.035-.037-.043.028-4.322 2.778-.043.028.019.047a3.67 3.67 0 0 1 0 2.666l-.019.047.043.028z"
  })));
};
const Memo = /*#__PURE__*/memo(SvgSharePurple);
export default Memo;